module.exports = __webpack_public_path__ + "static/img/3-6.9.5.ccf91e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/5/3-6.9.5.png
// module id = vl/h
// module chunks = 0